export const blogData = [
    {
        id: 3,
        title: 'XD to Flutter v2.0',
        description: 'Flutter 2 is an exciting step forward for the framework, with a focus on creating beautiful apps that work almost anywhere.',
        date: 'Oct 14, 2021',
        image: 'https://cdn.hashnode.com/res/hashnode/image/upload/v1634185849522/oWtj4CGte.png?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp',
        url: 'https://dattebayo.hashnode.dev/xd-to-flutter-v20'
    },
    {
        id: 2,
        title: 'Docker vs Kubernetes or Docker + Kubernetes?!',
        description: 'This article explains what containerization is and how Docker and Kubernetes can complement each other.',
        date: 'Oct 21, 2021',
        image: 'https://cdn.hashnode.com/res/hashnode/image/upload/v1634822436465/gkBUuky47.png?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp',
        url: 'https://dattebayo.hashnode.dev/docker-vs-kubernetes-or-docker-kubernetes'
    },
    {
        id: 1,
        title: 'AWS vs Azure vs GCP: A comparison of the 3 big cloud platforms',
        description: 'In this post, we will take a look at how these platforms stack up on each other.',
        date: 'Oct 17, 2021',
        image: 'https://cdn.hashnode.com/res/hashnode/image/upload/v1634477372617/JOrqaLeej.jpeg?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp',
        url: 'https://dattebayo.hashnode.dev/aws-vs-azure-vs-gcp-a-comparison-of-the-3-big-cloud-platforms'
    },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/